import { Icon, IconButton, Menu, MenuItem, Tooltip } from '@mui/material';
import { TableInstance } from 'react-table';
import { useMenu } from 'shared/hooks';
import { usePriceSheetExport, useProductExport, useProductRevisionExport } from 'shared/mutations';
import { Product } from 'shared/types';

type ExportActionButtonProps = {
    instance: TableInstance<Product>;
};

export default function ExportActionButton({ instance }: ExportActionButtonProps) {
    const [anchorEl, openMenu, closeMenu, open] = useMenu();
    const {
        totalCount,
        state: { sortBy, filters, globalFilter, showAll },
    } = instance;

    const exportMutation = useProductExport();
    const exportRevisionMutation = useProductRevisionExport();
    const priceSheetMutation = usePriceSheetExport();

    const exportProducts = () => {
        exportMutation.mutate({
            sortBy,
            filters,
            search: globalFilter,
            showApproved: showAll,
        });
        closeMenu();
    };

    const exportRevisionProducts = () => {
        exportRevisionMutation.mutate({
            sortBy,
            filters,
            search: globalFilter,
            showApproved: showAll,
        });
    };

    const exportPriceSheetThisWeek = () => {
        priceSheetMutation.mutate({ type: 'current' });
        closeMenu();
    };
    const exportPriceSheetLastWeek = () => {
        priceSheetMutation.mutate({ type: 'last' });
        closeMenu();
    };
    return (
        <>
            <Tooltip title='Export'>
                <IconButton onClick={openMenu} size='large'>
                    <Icon>download</Icon>
                </IconButton>
            </Tooltip>
            <Menu anchorEl={anchorEl} open={open} onClose={closeMenu}>
                <MenuItem onClick={exportProducts}>Export ({totalCount})</MenuItem>
                <MenuItem onClick={exportPriceSheetThisWeek}>Price Sheet (This Week)</MenuItem>
                <MenuItem onClick={exportPriceSheetLastWeek}>Price Sheet (Last Week)</MenuItem>
                <MenuItem onClick={exportRevisionProducts}>Revise Products ({totalCount})</MenuItem>
            </Menu>
        </>
    );
}
